import tags from "../../../components/tags";
import { icons } from "../../../components/html";
import { statusCodes } from "../../../components/responses";

export default {
  "/client/advisor-buttons": {
    get: {
      tags: [tags.businessAccount],
      summary: "List of defined Advisor buttons",
      description: `${icons.c}
      Return list of button "Recommend size", defined by the client in section "SizeId Advisor". This list contains information about buttons sizes in addition to the title.`,
      parameters: [
        { $ref: "#/components/parameters/acceptsLanguages" },
        {
          name: "name",
          in: "query",
          required: false,
          description: "Filtration based on button name",
          schema: {
            type: "string",
            example: "tlac"
          }
        },
        { $ref: "#/components/parameters/limit" },
        { $ref: "#/components/parameters/offset" }
      ],

      responses: {
        "200": {
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  id: {
                    type: "integer",
                    description:
                      "unique identifier of button within client - in the button code as data-sizeid-button-style",
                    example: 11
                  },
                  name: {
                    type: "string",
                    description: "button name",
                    example: "custom_button"
                  },
                  style: {
                    $ref: "#/components/schemas/buttonStyle"
                  }
                }
              }
            }
          }
        },
        ...statusCodes
      }
    }
  }
};
